import { render, staticRenderFns } from "./extra_card.vue?vue&type=template&id=73d2df44&scoped=true"
import script from "./extra_card.vue?vue&type=script&lang=js"
export * from "./extra_card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d2df44",
  null
  
)

export default component.exports